import { useEffect } from 'react';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { hasValue } from '@famly/stat_ts-utils_has-value';
/**
 * Use this hook to handle DOM events of any kind.
 *
 * @example
 * useEventHandler({
 *   target: useRef(document),
 *   eventName: 'scroll'
 *   handler: useCallback(e => {
 *     // Do something
 *   }, [])
 * });
 *
 */
export const useEventHandler = ({ target, skip, debounce = 100, eventName, handler, }) => {
    useEffect(() => {
        if (!hasValue(target.current) || skip) {
            return () => {
                /* */
            };
        }
        const listener = fromEvent(target.current, eventName).pipe(debounceTime(debounce)).subscribe(handler);
        return () => {
            listener.unsubscribe();
        };
    }, [target, skip, debounce, handler, eventName]);
};
